module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_decoration_image_01-78ef99b072ccadd26b99f7e52b103ec1.png";